import { useQuery } from '@tanstack/react-query';
import { getTopClimbers, getGameweeksWithVotes } from '@/api/gameweekLeaderboard';

/**
 * Fetch top climbers for home page section
 * If gameweekId is not provided, backend returns the last finished GW
 */
export function useTopClimbers(seasonId?: string, gameweekId?: string) {
  const query = useQuery({
    queryKey: ['profiles', 'top-climbers', seasonId, gameweekId],
    queryFn: () => getTopClimbers(seasonId!, gameweekId),
    enabled: !!seasonId,
    staleTime: 60 * 1000, // 1 min
  });

  return {
    data: query.data,
    loading: query.isLoading,
    error: query.error,
  };
}

/**
 * Fetch list of gameweeks that have votes (for dropdown filter)
 */
export function useGameweeksWithVotes(seasonId?: string) {
  const query = useQuery({
    queryKey: ['gameweeks', 'with-votes', seasonId],
    queryFn: () => getGameweeksWithVotes(seasonId!),
    enabled: !!seasonId,
    staleTime: 5 * 60 * 1000, // 5 min - rarely changes
  });

  return {
    gameweeks: query.data?.gameweeks ?? [],
    loading: query.isLoading,
  };
}
